import { withRouter, RouteComponentProps } from 'react-router-dom'; 
import * as React from 'react';

export const withRouterApp = <A extends {}>(component: any): React.FunctionComponent<A> => {
  let item = component as any;
  return withRouter(item) as any;
}

